import { render, staticRenderFns } from "./Enforcement.vue?vue&type=template&id=6e046c9c"
import script from "./Enforcement.vue?vue&type=script&setup=true&lang=js"
export * from "./Enforcement.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports